import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'

interface RecoveryReportRow {
  id: number
  documentInfo: string
  clientNames: string[]
  account: {
    number: string
    date: string
  }
  isPaid: {
    value: boolean
    label: string
  }
  waitingTime: {
    value: number
    label: string
  }
}

interface RecoveryReportTableProps {
  data: RecoveryReportRow[] | null | undefined
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}))

export default function RecoveryReportTable({ data }: RecoveryReportTableProps) {
  return (
    <TableContainer
      component={Paper}
      sx={{ border: '1px solid #e6e6e6', boxShadow: 0 }}
    >
      <Table sx={{ minWidth: 650 }} aria-label="recovery report table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              № услуги
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              Контрагент
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              Номер и дата счёта
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              Статус счёта
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              Время ожидания
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data && data?.length > 0 &&
            data.map((row) => {
              const billDate = row.account?.date
                ? dayjs(row.account.date).format('DD.MM.YYYY')
                : null

              return (
                <StyledTableRow key={row.id}>
                  <TableCell align="center">
                    <Link to={`/service-page/${row.id}`}>
                      {row.documentInfo}
                    </Link>
                  </TableCell>
                  <TableCell align="center">
                    {row.clientNames?.join(', ')}
                  </TableCell>
                  <TableCell align="center">
                    {row.account?.number}
                    {billDate ? ` от ${billDate}` : ''}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: row.isPaid?.value ? 'green' : 'red'
                    }}
                  >
                    {row.isPaid?.label || '—'}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: row.waitingTime?.value ? 'red' : 'inherit' }}
                  >
                    {row.waitingTime?.label || '—'}
                  </TableCell>
                </StyledTableRow>
              )
            })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
